import GetRuns from './GetRuns';
import GetEntities from './GetEntities';
import GetCandidates from './GetCandidates';
import ResolveEntity from './ResolveEntity';
import TriggerSync from './TriggerSync';

const SignJetSync = {
  signJetSyncRuns: GetRuns,
  signJetSyncEntities: GetEntities,
  signJetSyncCandidates: GetCandidates,
  signJetSyncResolve: ResolveEntity,
  signJetSyncTrigger: TriggerSync,
};

export default SignJetSync;
